import type React from 'react'

import { SkeletonBlock } from './SkeletonBlock'

interface SkeletonTableProps {
  columns: number
  rows?: number
  className?: string
}

export const SkeletonTable: React.FC<SkeletonTableProps> = ({
  columns,
  rows = 3,
  className = '',
}) => (
  <div className={className} aria-hidden="true">
    <table className="min-w-full border-separate border-spacing-0">
      <thead>
        <tr>
          {Array.from({ length: columns }, (_, columnIndex) => (
            <th
              key={`header-${columnIndex}`}
              className="border-b border-gray-200 px-3 py-2 text-left"
            >
              <SkeletonBlock className="h-4 w-24" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }, (_, rowIndex) => (
          <tr key={`row-${rowIndex}`}>
            {Array.from({ length: columns }, (_el, columnIndex) => (
              <td
                key={`cell-${rowIndex}-${columnIndex}`}
                className="border-b border-gray-100 px-3 py-2"
              >
                <SkeletonBlock
                  className={columnIndex === columns - 1 ? 'h-4 w-full' : 'h-4 w-32'}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
